import { configStore } from '@commons/store/config.store'
import { errorStore } from '@commons/store/error.store'

import { activityAreaStore } from '@directory/store/activityArea.store'
import { docTagStore } from '@directory/store/docTag.store'

import { documentStore } from "@main/store/document.store"
import { documentFileStore } from "@main/store/documentFile.store"
import { initialOrderStore } from "@main/store/initialOrder.store"
import { changeOrderStore } from "@main/store/changeOrder.store"
import { searchStore } from "@main/store/search.store"
import { subdivisionStore } from "@main/store/subdivision.store"

export default {
  modules: {
    config: { namespaced: true, ...configStore },
    error: { namespaced: true, ...errorStore },
    activityArea: { namespaced: true, ...activityAreaStore },
    docTag: { namespaced: true, ...docTagStore },
    document: { namespaced: true, ...documentStore },
    documentFile: { namespaced: true, ...documentFileStore },
    initialOrder: { namespaced: true, ...initialOrderStore },
    changeOrder: { namespaced: true, ...changeOrderStore },
    subdivision: { namespaced: true, ...subdivisionStore },
    search: { namespaced: true, ...searchStore }
  },
  actions: {
    // TODO: впоследствии реализовать функцию
    resetStores({ commit }) {

    }
  }
}
